<template>
  <el-dialog
    v-dialogDrag
    :title="`${$t('importFromExcel')}`"
    :visible.sync="uploadExcelProps.visible"
    :close-on-click-modal="false"
    :modal-append-to-body="modalAppendToBody"
    :custom-class="customClass"
    :modal="needModal"
  >
    <el-steps :active="active" align-center finish-status="success" class="mt-20px">
      <el-step
        class="text-14px"
        :title="`${$t('downloadTheTemplate')}`"
        @click="downloadTemplate"
      ></el-step>
      <el-step :title="`${$t('uploadTheFile')}`"></el-step>
      <el-step :title="`${$t('finish')}`"></el-step>
    </el-steps>
    <div v-show="active === 1">
      <div class="text-center pt-30px">
        <div class="upload-demo">
          <div class="el-upload el-upload--text down-text">
            <div class="mt-25px">
              <i
                @click="downloadTemplate"
                class="icon iconfont icon-line-excel h-full text-70px text-green"
              ></i>
              <div class="el-upload__text">
                {{ `${$t('clickTheIconToDownloadTheTemplateFill')}` }}
                <em class="text-color" @click="nextStep">{{ `${$t('next')}` }}</em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="active === 2" class="text-center">
      <el-upload
        v-loading="loading"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        :multiple="false"
      >
        <i class="el-icon-upload text-67px"></i>
        <div class="el-upload__text">
          {{ `${$t('uploadTheFileTwo')}` }}
          <em>{{ `${$t('clickUpload')}` }}</em>
        </div>
      </el-upload>
    </div>
    <div class="padding-1" v-show="active === 3">
      <div class="text-center">
        <div class="upload-demo">
          <div class="el-upload el-upload--text down-text">
            <div class="mt-25px pt-20px">
              <span class="mt-30px">
                <i class="iconfont icon-bg-complete text-54px text-green"></i>
              </span>
              <div class="el-upload__text">{{ `${$t('theUploadIsSuccessful')}` }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" v-if="active !== 3" size="small" :loading="loading">{{
        `${$t('cancel')}`
      }}</el-button>
      <el-button
        v-if="active === 2"
        type="primary"
        size="small"
        @click="active = 1"
        :loading="loading"
        >{{ `${$t('previousStep')}` }}</el-button
      >
      <el-button
        v-if="active === 3"
        type="primary"
        size="small"
        @click="closeDialog"
        :loading="loading"
        >{{ `${$t('finish')}` }}</el-button
      >
      <el-button
        v-if="active === 1"
        type="primary"
        size="small"
        @click="nextStep"
        :loading="loading"
        >{{ `${$t('next')}` }}</el-button
      >
      <el-button @click="active = 2" v-if="active === 3" size="small">
        {{ `${$t('previousStep')}` }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import FnMixins from '@/assets/js/fnMixins'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { TrendAlarmModelConfigApi } from '@wiz-api/trend-alarm-management'
import { FaultModelConfigApi } from '@wiz-api/fault-diagnosis-management'
import { ThresholdAlarmConfigApi } from '@wiz-api/threshold-alarm-management'
import { EquipDisAssembleySolutionApi } from '@wiz-api/equipment-assembly-trainning'

const categoryApi = new DataCategoryApi()
const faultModelConfigApi = new FaultModelConfigApi()
const trendAlarmModelConfigApi = new TrendAlarmModelConfigApi()
const thresholdConfigApi = new ThresholdAlarmConfigApi()
const equipDisAssembleySolution = new EquipDisAssembleySolutionApi()

export default {
  name: 'uploadExcel',
  mixins: [FnMixins],
  props: {
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @param {excel类型} excelType
     * @return {*}
     */
    uploadExcelProps: {
      type: Object,
      default: () => {
        return {
          visible: false,
          title: '',
          excelType: '',
        }
      },
    },
    catalogId: {
      type: String,
    },
    excelType: {
      type: String,
    },
    attrType: {
      type: Number,
    },
    customization: {
      type: Boolean,
      default: false,
    },
    isExcel: {
      type: Boolean,
      default: false,
    },
    // 遮罩层
    modalAppendToBody: {
      type: Boolean,
      default: false,
    },
    // 弹窗自定义类名
    customClass: {
      type: String,
      default: '',
    },
    needModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      uploadExcelVisible: false,
      successCallBackData: null,
      active: 1,
      file: '',
      loading: false,
      progressPercent: 1,
      timer: null,
      currentUploadFileId: '',
      startTimer: true,
      varTimer: null,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  watch: {},
  created() {
    console.log('dnvshvug')
  },
  beforeDestroy() {
    this.varTimer = null
  },
  methods: {
    // 下载模板
    async downloadTemplate() {
      switch (this.uploadExcelProps.excelType) {
        case 'thresholdConfigDocument': // 数据字典模板下载
          const [
            thresholdConfigErr,
            thresholdConfigRes,
          ] = await thresholdConfigApi.getThresholdAlarmConfigImportTemplate()
          if (!thresholdConfigErr) {
            this.downLoadBlob({
              name: '阈值报警配置模板.xlsx',
              data: thresholdConfigRes,
            })
          }
          break
        case 'dataDictionary': // 数据字典模板下载
          const [err, dataDictionaryRes] = await categoryApi.getTemplateExcelFile()
          if (!err) {
            this.downLoadBlob({
              name: '数据字典模板.xlsx',
              data: dataDictionaryRes,
            })
          }
          break
        case 'trendAlarmConfigurationDocument': // 趋势报警配置导入模板下载
          const [
            modelConfigErr,
            modelConfigRes,
          ] = await trendAlarmModelConfigApi.downloadTemplateFile()
          // 返回的是文件流
          if (!modelConfigErr) {
            this.downLoadBlob({
              name: '趋势报警导入模板.xlsx',
              data: modelConfigRes,
            })
          }
          break
        case 'troubleDocument': // 故障模型导入模板下载
          const [
            troubleConfigErr,
            troubleConfigRes,
          ] = await faultModelConfigApi.downloadTemplateFile()
          // 返回的是文件流
          if (!troubleConfigErr) {
            this.downLoadBlob({
              name: '故障模型导入模板.xlsx',
              data: troubleConfigRes,
            })
          }
          break
        case 'stepList':
          const [
            stepListErr,
            stepListRes,
          ] = await equipDisAssembleySolution.getImportStepsTemplate()
          if (!stepListErr) {
            this.downLoadBlob({
              name: '步骤列表导入模板.xlsx',
              data: stepListRes,
            })
          }
          break
        default:
          break
      }
    },
    // 下一步
    nextStep() {
      this.active += 1
      if (this.active > 2) {
        this.active = 1
      }
    },
    // 获取上传的内容
    // eslint-disable-next-line consistent-return
    getFileContent(file) {
      this.file = file
      if (this.isExcel) {
        const format = file.name.substring(file.name.lastIndexOf('.') + 1)
        const suffix = format === 'xls' || format === 'xlsx'
        if (!suffix) {
          this.$message.error('文件格式错误，请上传excel文件')
          return false
        }
        return suffix
      }
    },
    // 上传
    async uploadExcel() {
      this.loading = true
      let err
      let res
      const formData = new FormData()
      if (
        this.uploadExcelProps.excelType === 'trendAlarmConfigurationDocument' ||
        this.uploadExcelProps.excelType === 'troubleDocument'
      ) {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('fileInput', value)
        })
      } else if (this.uploadExcelProps.excelType === 'trendPredictionVar') {
        // 趋势预测模块-导入变量
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('excelFile', value)
        })
      } else if (this.uploadExcelProps.excelType === 'pointList') {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('input', value)
        })
      } else if (this.uploadExcelProps.excelType === 'equipmentList') {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('file', value)
        })
        formData.append('catalogId', this.catalogId)
      } else if (this.uploadExcelProps.excelType === 'measuringPointsList') {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('file', value)
        })
      } else if (this.uploadExcelProps.excelType === 'thresholdConfigDocument') {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('file', value)
        })
      } else if (this.uploadExcelProps.excelType === 'departmentManagement') {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('files', value)
        })
      } else if (this.uploadExcelProps.excelType === 'staffManagement') {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('files', value)
        })
      } else if (this.uploadExcelProps.excelType === 'stepList') {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('file', value)
        })
      } else {
        _.forIn({ file: this.file }, (value, key) => {
          formData.append('excelFile', value)
        })
      }

      if (!_.isEmpty(this.excelParams)) {
        _.forIn(this.excelParams, (value, key) => {
          formData.append(key, value)
        })
      }
      switch (this.uploadExcelProps.excelType) {
        case 'dataDictionary': // 数据字典
          ;[err, res] = await categoryApi.importFromExcelFile({
            excelFile: formData.get('excelFile'),
          })
          break
        case 'thresholdConfigDocument':
          ;[err, res] = await thresholdConfigApi.importThresholdAlarmConfig({
            reqData: formData,
          })
          break
        case 'trendAlarmConfigurationDocument':
          ;[err, res] = await trendAlarmModelConfigApi.importExcel({
            fileInput: formData.get('fileInput'),
          })
          break
        case 'troubleDocument':
          ;[err, res] = await faultModelConfigApi.importExcel({
            fileInput: formData.get('fileInput'),
          })
          break
        case 'stepList':
          ;[err, res] = await equipDisAssembleySolution.importSteps(
            this.uploadExcelProps.schemeId,
            {
              file: formData.get('file'),
            }
          )
          break
        default:
          break
      }
      this.loading = false
      if (!err) {
        this.active = 3
        this.$message.success(this.$t('theImportToExcelIsSuccessful'))
      }
    },
    closeDialog() {
      this.$emit('refreshList')
      this.active = 1
      this.file = ''
      this.uploadExcelProps.visible = false
    },
  },
}
</script>

<style scoped lang="scss">
::deep.el-step.is-simple ::deep.el-step__title {
  font-size: 15px !important;
}
::v-depp .el-upload-dragger {
  background-color: #ffffff1a !important;
  .el-upload__text {
    color: #fff !important;
    em {
      color: #0055ff !important;
    }
  }
}
::v-deep .el-dialog__body{
  overflow: auto !important;
}
</style>
